import { UPDATE_STORE_STAT_WIDGET } from "./actionTypes";

const initialState = {
  data : {}
};

const storeStatWidget = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_STORE_STAT_WIDGET:
      state = { ...state, data: action.payload};
      break;
    
    default:
      break;
  }
  return state;
};

export default storeStatWidget;
